"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LevelBadge = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_i18next_1 = require("react-i18next");
// Värikoodit tasohierarkian mukaan (master korkein → basic matalin).
var levelClasses = {
    master: 'bg-purple-100 text-purple-800',
    admin: 'bg-blue-100 text-blue-800',
    editor: 'bg-green-100 text-green-800',
    basic: 'bg-gray-100 text-gray-800',
};
var LevelBadge = function (_a) {
    var _b;
    var level = _a.level;
    var t = (0, react_i18next_1.useTranslation)('UserLevel').t;
    if (!level)
        return (0, jsx_runtime_1.jsx)("span", { className: "text-gray-400", children: "-" });
    var classes = (_b = levelClasses[level]) !== null && _b !== void 0 ? _b : 'bg-gray-100 text-gray-800';
    return ((0, jsx_runtime_1.jsx)("span", { className: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ".concat(classes), children: t(level, { defaultValue: level }) }));
};
exports.LevelBadge = LevelBadge;
